import React from 'react';
import { ConversationProvider } from '@elevenlabs/react';
import VoiceAgent from './components/VoiceAgent';
import './App.css';

function App() {
  return (
    <ConversationProvider>
      <div className="App">
        <VoiceAgent />
      </div>
    </ConversationProvider>
  );
}

export default App;
